import { r } from '@/theme/tokens';
import { Box, Skeleton } from '@/ui/primitives';
import type { ReactElement } from 'react';

type StatusPieCardSkeletonProps = {
  size?: number;
  innerSize?: number;
};

export const StatusPieCardSkeleton = ({
  size = 164,
  innerSize = 72,
}: StatusPieCardSkeletonProps): ReactElement => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box sx={{ position: 'relative', width: size, height: size }}>
        <Skeleton variant="circular" width={size} height={size} />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: innerSize,
            height: innerSize,
            transform: 'translate(-50%, -50%)',
            borderRadius: r('pill'),
            backgroundColor: 'var(--surface-card)',
          }}
        />
      </Box>
    </Box>
  );
};
